import { User, UserRole } from "../types";

const normalizeNumericIds = (raw: unknown): number[] => {
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw
    .map((id) => Number.parseInt(String(id), 10))
    .filter((id) => !Number.isNaN(id));
};

export const getAllowedWorkflowIds = (settingsJson?: string): number[] => {
  if (!settingsJson) {
    return [];
  }
  try {
    const settings = JSON.parse(settingsJson);
    return normalizeNumericIds(settings?.workflowPermissions?.allowedWorkflowIds);
  } catch {
    return [];
  }
};

export const isProjectManagerAllowedForTemplate = (
  user: User | null | undefined,
  templateWorkflowId: number | null | undefined
): boolean => {
  if (!user || user.role !== UserRole.PROJECT_MANAGER) {
    return false;
  }
  if (!templateWorkflowId) {
    return false;
  }
  const allowed = getAllowedWorkflowIds(user.settingsJson);
  return allowed.includes(templateWorkflowId);
};

